<template>
  <div v-if="isPageLoaded" class="darkBlue-bg ">
    <div class="container">
      <div class="row justify-content-between">
        <div class=" justify-content-center ">
          <img :src="getImgUrl(logo)" class="img-fluid" width="70%"/>
        </div>
        <div class="row">
          <div class="col-12 col-md-3 ">
            <div class="white--text font-14 mb-5 text-right"> آدرس دفتر مرکزی:</div>
            <div class="white--text font-14 mb-5 text-right"> تهران- ابتدای جاده دماوند- خیابان سازمان آب- خیابان کاظم
              نشوه- بن بست یکم انیسی- پلاک 25
            </div>
            <div class="white--text font-14 mb-5 text-right"><a href="tel:09125178114">09125178114</a></div>
            <div class="white--text font-14 mb-5 text-right"> واحد فروش ماشین آلات تزریق پلاستیک:
              <a href="tel:02177393392">77393392</a>
              –
              <a href="tel:02177393393">77393393</a>
            </div>
            <!--   <div class="col white&#45;&#45;text pt-6" v-html="PageContent.description"></div>-->
          </div>
          <div class="col-12 col-md-3 ">
            <div class="white--text font-14 mb-5 text-right"> آدرس کارخانه :</div>
            <div class="white--text font-14 mb-5 text-right"> تهران- 28 کیلومتری جاده دماوند- شهرک صنعتی خرمدشت- بیست
              متری شرقی- خیابان پنجم خرمدشت- پلاک 17
            </div>
            <div class="white--text font-14 mb-5 text-right"><a href="tel:09124597441">09124597441</a></div>

            <div class="white--text font-14 mb-5 text-right"> واحد تزریق قطعات پلاستیک:
              <a href="tel:02176215076">76215076</a>
            </div>
            <!--   <div class="col white&#45;&#45;text pt-6" v-html="PageContent.description"></div>-->
          </div>
          <div class="col-12 col-md-3">
            <!--          <router-link to="allProducts">
                        <div class="font18 mb-5 primary-color white&#45;&#45;text text-right">محصولات ما</div>
                      </router-link>
                      <div v-for="item in Products" :key="item.id">
                        <router-link :to="{path:'productDetails',query:{productId:item.id}}">
                          <div class="mt-3 text-right">{{ item.productName }}</div>
                        </router-link>
                      </div>-->
            <gmap-map
                ref="map"
                :center="center"
                :zoom="12"
                style="width: 100%; height: 200px"
            >
              <gmap-marker
                  v-for="(m, index) in markers"
                  :key="index"
                  :position="m"/>
            </gmap-map>
          </div>
          <div class="col-12 col-md-3 ">
            <router-link to="contactUs">
              <div class="white--text font-14 mb-5 text-center"> ما را دنبال کنید</div>
            </router-link>
            <div class="row ">
              <div v-for="item in socialNetworkItems"
                   :key="item.id" class=" col">
                <a :href="item.link" target="_blank">
                  <div class="row center">
                    <img :alt=item.title :src="$replaceHttps(item.imageUrl)" class="col-6 ">
                    <!--                <div class="col-7 col-md-8">{{ item.title }}</div>-->
                  </div>
                  <!--                                <div class="mt-2">{{ item.description }}</div>-->
                </a>
              </div>
              <div class="white--text font-12 mt-8 text-right"> کلیه حقوق مادی و معنوی این سایت مربوط به شرکت ماشین
                سازان اصلانیان میباشد
              </div>
              <div class="white--text font-12">
                طراح شرکت
                <a href="https://izisys.com/" target="_blank"> ایده زرین پرهام</a>
                میباشد.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footerMenu",
  data: () => ({
    center: {lat: 35.737613677978516, lng: 51.777713775634766},
    markers: [
      {
        lat: 35.737613677978516,
        lng: 51.777713775634766,
      },
    ],
    logo: 'logo-footer2.png',
    isPageLoaded: false,
    PageContent: null,
    socialNetworkItems: [],
    Products: [],
  }),
  mounted () {
    this.getData()
    this.getSocialNetwork()
    this.getProducts()
  },
  methods: {
    getImgUrl (pic) {
      return require("../assets/img/" + pic);
    },
    getSocialNetwork () {
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/SocialNetwork", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.socialNetworkItems = json
          })
          .catch(error => console.log('error', error));
    },
    getProducts () {
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/Products", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.isPageLoaded = true
            let json = JSON.parse(result)
            this.Products = json.filter(x => x.isActive === true)
            console.log("this.Products")
            console.log(this.Products)

          })
          .catch(error => console.log('error', error));
    },
    getData () {

      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/PageContent?TypePage=1", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.PageContent = JSON.parse(result)
            console.log(this.PageContent)
            this.isPageLoaded = true
          })
          .catch(error => console.log('error', error));
    },

  }

}
</script>

<style scoped>

</style>
